define('SC.SummitThemeExtension.ApplicationSkeleton.Layout', [
  'SC.SummitThemeExtension.Common.Configuration',
  'SC.SummitThemeExtension.Common.UtilitiesHelper'
], function QSApplicationSkeletonLayout(
  Configuration,
  Utils
) {
  'use strict';
  return {
    toggleViewportToMobileSupport: function toggleViewportToMobileSupport() {
      Utils.toggleViewportToMobileSupport();
    },
    loadModule: function loadModule() {

        var fixedHeader = Configuration.get('header.fixedHeader');

        var HeaderHeight;

        jQuery(window).scroll(function () {

          if (!HeaderHeight){
            HeaderHeight = jQuery('#site-header').outerHeight(true);
          }

          var y = jQuery(this).scrollTop();

          //validating if fixedHeader is true.
          if (fixedHeader) {//if fixedHeader is enabled in configuration, this code will run.

            //validating if screen is enough for desktop.
            if ($(window).width() > 992) {
              if (jQuery('header').hasClass('checkout-layout-header')) {
                //do nothing
              } else {
                if (y >= 300 && y < 600) {
                  jQuery('body').addClass('fixed-header');
                  jQuery('#main-container').css('padding-top', HeaderHeight);
                }
                if (y < 1) {
                  jQuery('body').removeClass('fixed-header');
                  jQuery('#main-container').css('padding-top', '0px');
                }
              }
            }
        }

        //Mobile fixed header is not optional, so we'll run it from outside the fixedHeader conditional.
        if ($(window).width() < 992) {//checking the screen-size
          if (jQuery('header').hasClass('checkout-layout-header')) {
            //do nothing
          } else {
            if (y >= 100 && y < 200) {//the header is a lot smaller, so we'll set a 100points scroll instead of 300
              jQuery('body').addClass('fixed-header-mobile');
              jQuery('#main-container').css('padding-top', '0px');//this resolve a weird responsive behavior.
            }
            if (y < 99) {
              jQuery('body').removeClass('fixed-header-mobile');
              $('.header-menu-cart').find('.open').removeClass('open');
               // This resolves the twice-click on mini-cart's icon when mini-cart is hidden under the next two situation: 
               // 1) When mini-cart is open at the top of the page (mini-cart is at the right position) and the page is scrolled down (mini-cart is moved to the left position)
               // 2) When mini-cart is open not at the top of the page (mini-cart is at left position)  and the page is scrolled up the top  (mini-cart is moved to the right position)
              $('.header-menu-cart').find('.dropdown-backdrop').remove();
            }
          }
        }
      });
    }
  }
});
